export default __webpack_public_path__ + "static/media/man2.0265aa55.jpg";